import React, { lazy } from 'react';
import { CardProps } from 'libs/growth-platform-brand-system-v2/src/components/Card';
const MultipleImageCard = lazy (() => import('libs/growth-platform-brand-system-v2/src/components/Card/MultipleImageCard'))
const MultipleBlogsCard = lazy (() => import('libs/growth-platform-brand-system-v2/src/components/Card/MultipleBlogsCard'))
const FormCard = lazy (() => import('libs/growth-platform-brand-system-v2/src/components/Card/FormCard'))
const ArticleCard = lazy (() => import('libs/growth-platform-brand-system-v2/src/components/Card/ArticleCard'))
const QuoteCard = lazy (() => import('libs/growth-platform-brand-system-v2/src/components/Card/QuoteCard'))

export const CardSelected = ({ children, ...props }: CardProps) => {
  const type = props.type;

  return (
    <>
      {type === 'multipleImages' && (
        <MultipleImageCard {...props}>{children}</MultipleImageCard>
      )}
      {type === 'multipleBlogs' && (
        <MultipleBlogsCard {...props}>{children}</MultipleBlogsCard>
      )}
      {type === 'form' && <FormCard {...props}>{children}</FormCard>}
      {(type === 'article' || type === 'multipleArticles') && (
        <ArticleCard {...props}>{children}</ArticleCard>
      )}
      {(type === 'quote' ||
        type === 'multipleQuotes' ||
        type === 'quoteWithImg') && (
        <QuoteCard {...props}>{children}</QuoteCard>
      )}
    </>
  );
};
